export default [
  {
    route: 'account',
    label: 'profile.navbar.account',
    action: 'views.account.read',
    exact: false
  },
  {
    route: 'profile',
    label: 'profile.navbar.profile',
    action: 'views.profile.read',
    exact: false
  },
  {
    route: 'config',
    label: 'profile.navbar.clientConfig',
    action: 'views.clientConfig.read',
    exact: false
  },
  {
    route: 'admins',
    label: 'admins.title',
    action: 'views.admins.read',
    exact: false
  }
];
